"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogService_1 = require("./DialogService");
exports.default = DialogService_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/service/index.js
// module id = 938
// module chunks = 8